/* Leadway Digital — Three.js Hero Scene
   Vanilla JS — runs after THREE is loaded via CDN */
(function () {
  'use strict';

  function init() {
    /* Skip WebGL in the Shopify theme editor — avoids unnecessary RAF overhead */
    if (window.Shopify && window.Shopify.designMode) return;
    var canvas = document.getElementById('hero-canvas');
    if (!canvas || typeof THREE === 'undefined') return;

    var W = canvas.offsetWidth;
    var H = canvas.offsetHeight;

    // Renderer
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(W, H);
    renderer.outputEncoding = THREE.sRGBEncoding;

    // Scene
    var scene = new THREE.Scene();

    // Camera
    var camera = new THREE.PerspectiveCamera(42, W / H, 0.1, 100);
    camera.position.set(0, 0, 8);

    // Lights
    var ambient = new THREE.AmbientLight(0xffffff, 0.15);
    scene.add(ambient);

    var pLight1 = new THREE.PointLight(0x00d48a, 4, 15); // green
    pLight1.position.set(4, 4, 4);
    scene.add(pLight1);

    var pLight2 = new THREE.PointLight(0x3b82f6, 3, 12); // blue
    pLight2.position.set(-4, -2, -4);
    scene.add(pLight2);

    var pLight3 = new THREE.PointLight(0x00d48a, 2, 10); // green fill
    pLight3.position.set(0, -5, 3);
    scene.add(pLight3);

    var pLight4 = new THREE.PointLight(0xffffff, 1.5, 8);
    pLight4.position.set(0, 3, -2);
    scene.add(pLight4);

    // ── Main shape (icosahedron) ──
    var icoGeo = new THREE.IcosahedronGeometry(1.6, 1);
    var icoMat = new THREE.MeshPhysicalMaterial({
      color: 0x00b076,
      emissive: 0x003d26,
      emissiveIntensity: 0.4,
      metalness: 0.88,
      roughness: 0.06,
      clearcoat: 1.0,
      clearcoatRoughness: 0.08,
      reflectivity: 1,
    });
    var icoMesh = new THREE.Mesh(icoGeo, icoMat);
    scene.add(icoMesh);

    // Drop-in state
    icoMesh.position.y = 12;
    var dropTarget = 0;
    var hasLanded = false;

    // ── Orbiting rings ──
    function makeRing(radius, tube, color, opacity) {
      var geo = new THREE.TorusGeometry(radius, tube, 16, 100);
      var mat = new THREE.MeshBasicMaterial({ color: color, transparent: true, opacity: opacity, side: THREE.DoubleSide });
      return new THREE.Mesh(geo, mat);
    }
    var ring1 = makeRing(2.4, 0.016, 0x00d48a, 0.22);
    var ring2 = makeRing(3.1, 0.011, 0x3b82f6, 0.16);
    var ring3 = makeRing(3.8, 0.007, 0x00d48a, 0.10);
    scene.add(ring1, ring2, ring3);

    // ── Particles ──
    var ptCount = 130;
    var ptPos = new Float32Array(ptCount * 3);
    for (var i = 0; i < ptCount; i++) {
      var r = 3 + Math.random() * 4;
      var theta = Math.random() * Math.PI * 2;
      var phi = Math.acos(2 * Math.random() - 1);
      ptPos[i * 3]     = r * Math.sin(phi) * Math.cos(theta);
      ptPos[i * 3 + 1] = r * Math.sin(phi) * Math.sin(theta);
      ptPos[i * 3 + 2] = r * Math.cos(phi);
    }
    var ptGeo = new THREE.BufferGeometry();
    ptGeo.setAttribute('position', new THREE.BufferAttribute(ptPos, 3));
    var ptMat = new THREE.PointsMaterial({ size: 0.032, color: 0x6ee7b7, transparent: true, opacity: 0.65, sizeAttenuation: true });
    var particles = new THREE.Points(ptGeo, ptMat);
    scene.add(particles);

    // ── Animation ──
    var clock = new THREE.Clock();

    function animate() {
      requestAnimationFrame(animate);
      var t = clock.getElapsedTime();

      // Drop entrance
      if (!hasLanded) {
        icoMesh.position.y += (dropTarget - icoMesh.position.y) * 0.035;
        if (Math.abs(icoMesh.position.y - dropTarget) < 0.04) {
          icoMesh.position.y = dropTarget;
          hasLanded = true;
        }
      } else {
        // Float
        icoMesh.position.y = Math.sin(t * 0.75) * 0.18;
      }

      // Rotation
      icoMesh.rotation.x += 0.005;
      icoMesh.rotation.y += 0.009;
      icoMesh.rotation.z += 0.003;

      // Rings
      ring1.rotation.x += 0.007;
      ring1.rotation.y += 0.003;
      ring2.rotation.x -= 0.005;
      ring2.rotation.z += 0.006;
      ring3.rotation.y += 0.009;
      ring3.rotation.z -= 0.004;

      // Particles
      particles.rotation.y += 0.0012;
      particles.rotation.x = Math.sin(t * 0.04) * 0.08;

      // Animated lights orbit
      pLight1.position.x = Math.sin(t * 0.5) * 5;
      pLight1.position.y = Math.cos(t * 0.3) * 3;
      pLight2.position.x = Math.cos(t * 0.4) * -4;
      pLight2.position.z = Math.sin(t * 0.6) * 3;

      renderer.render(scene, camera);
    }

    animate();

    // ── Resize ──
    window.addEventListener('resize', function () {
      var W2 = canvas.offsetWidth;
      var H2 = canvas.offsetHeight;
      camera.aspect = W2 / H2;
      camera.updateProjectionMatrix();
      renderer.setSize(W2, H2);
    });
  }

  // Wait for THREE to be available
  if (typeof THREE !== 'undefined') {
    init();
  } else {
    window.addEventListener('load', function () {
      if (typeof THREE !== 'undefined') init();
    });
  }
})();
